import { z } from "zod";

export const DTOTransferOwnershipPayload = z.object({
  newOwnerId: z.string(),
});

export type DTOTransferOwnershipPayload = z.infer<typeof DTOTransferOwnershipPayload>;
